import type { HTMLAttributes, RefObject, TargetedEvent } from 'preact';
import cn from 'classnames';
import styles from './SubscriptionRadio.module.scss';

export type SubscriptionRadioProps = HTMLAttributes<HTMLInputElement> & {
  label?: string;
  id: string;
  disabled?: boolean;
  value?: string;
  type?: string;
  name?: string;
  checked?: boolean;
  onChange?: (e: TargetedEvent<HTMLInputElement>) => void;
  inputRef?: RefObject<HTMLInputElement>;
};

function SubscriptionRadio({
  label,
  id,
  disabled,
  inputRef,
  ...rest
}: SubscriptionRadioProps) {
  return (
    <div class={styles.container}>
      <input
        type="radio"
        id={id}
        class={styles.input}
        disabled={disabled}
        ref={inputRef}
        onClick={(e: Event) => {
          e.stopPropagation();
        }}
        {...rest}
      />
      {label ? (
        <label
          class={cn(styles.label, { [styles.disabled]: disabled })}
          htmlFor={id}
        >
          {label}
        </label>
      ) : null}
    </div>
  );
}

export default SubscriptionRadio;
